import { render, staticRenderFns } from "./BookWidgetView.vue?vue&type=template&id=251ba7cf&scoped=true&"
import script from "./BookWidgetView.vue?vue&type=script&lang=ts&"
export * from "./BookWidgetView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251ba7cf",
  null
  
)

export default component.exports